import { useState } from 'react';
import { LogIn } from 'lucide-react';
import AuthModal from './AuthModal';

export default function LoginButton() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-pink-600 to-violet-600 rounded-lg font-semibold hover:opacity-90 transition"
      >
        <LogIn className="w-5 h-5" />
        <span>Log In</span>
      </button>

      {showModal && <AuthModal onClose={() => setShowModal(false)} />}
    </>
  );
}
